/**
 * Phase 23 (Plan 23-02) — Shadcn skeleton primitive.
 *
 * Confirmed missing from `aryan-onm-v2/frontend/src/components/ui/` per PATTERNS §A.
 * Used by every dashboard widget's loading branch (`<WidgetSkeleton />`).
 */

import type { HTMLAttributes, JSX } from 'react';

import { cn } from '@/lib/utils/cn';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      data-slot="skeleton"
      data-testid="skeleton"
      className={cn('bg-muted animate-pulse rounded-md', className)}
      {...props}
    />
  );
}
